import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { Button, Popup, RecordSelect, Popconfirm } from '@smartplatform/ui';
import { userFull } from '../../utils';
import store from '../../store';

@observer
export default class AccessPopup extends React.Component {

	@observable editors = [];
	@observable adding = false;
	@observable selectedUser = null;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.editors = await store.model.PageEditor.find({
			where: { pageId: this.props.page.id },
			include: ['user'],
			order: 'id desc',
		});
	};
	
	add = () => this.adding = true;
	cancel = () => this.adding = false;
	
	onUserChange = (user) => this.selectedUser = user;
	
	addEditor = async () => {
		const editor = new store.model.PageEditor();
		editor.pageId = this.props.page.id;
		editor.userId = this.selectedUser.id;
		await editor.save();
		this.adding = false;
		this.props.onChange && this.props.onChange();
		this.init();
	};
	
	deleteEditor = async (editor) => {
		await editor.delete();
		this.props.onChange && this.props.onChange();
		this.init();
	};
	
	render() {
		const { onClose } = this.props;
		
		return <Popup onClose={onClose} header="Доступ к редактированию" className="access-popup">
			<div className="actions">
				{this.adding ?
					<>
						<RecordSelect
							model={store.model.User}
							computed={userFull}
							value={this.selectedUser}
							filter={{ where: { userId: { nin: this.editors.map(editor => editor.userId) }}}}
							onChange={this.onUserChange}
						/>
						<Button className="btn-primary" onClick={this.addEditor} disabled={!this.selectedUser}>Ok</Button>
						<Button className="btn-primary" onClick={this.cancel}>Отмена</Button>
					</>
					:
					<Button className="btn-primary" onClick={this.add}>Добавить</Button>
				}
			</div>
			<div className="users">
				{this.editors.map(editor => <div key={editor.id}>
					<div className="user">{userFull(editor.user)}</div>
					<div className="action">
						<Popconfirm content="Удалить?" onConfirm={() => this.deleteEditor(editor)}>
							<Button className="btn-primary btn-xs">Удалить</Button>
						</Popconfirm>
					</div>
				</div>)}
			</div>
		</Popup>;
	}
	
}
